import React, { useRef } from "react";
import "./AerospaceAccelerator.css";

const ITNonITAccelerator = () => {
  const scrollRef = useRef(null);

  const scrollLeft = () => {
    if (scrollRef.current) {
      const cardWidth = scrollRef.current.firstChild.offsetWidth + 20;
      scrollRef.current.scrollBy({ left: -cardWidth, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      const cardWidth = scrollRef.current.firstChild.offsetWidth + 20;
      scrollRef.current.scrollBy({ left: cardWidth, behavior: "smooth" });
    }
  };

  const cards = [
    {
      image:
        "https://images.unsplash.com/photo-1534665482403-a909d0d97c67?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDN8fHNvZnR3YXJlfGVufDB8fDB8fHwy",
      title: "Software Development",
      description:
        "Custom IT solutions for web, mobile, and enterprise platforms to accelerate digital transformation.",
    },
    {
      image:
        "https://images.unsplash.com/photo-1487611459768-bd414656ea10?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTQzfHxzb2Z0d2FyZXxlbnwwfHwwfHx8Mg%3D%3D",
      title: "Cloud & Infrastructure",
      description:
        "Modern cloud adoption frameworks, migration strategies, and infrastructure management services.",
    },
    {
      image:
        "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fHNvZnR3YXJlfGVufDB8fDB8fHwy",
      title: "Business Operations",
      description:
        "Streamlining HR, finance, and back-office functions with automation and process excellence.",
    },
    {
      image:
        "https://images.unsplash.com/photo-1570215171424-f74325192b55?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTEzfHxzb2Z0d2FyZXxlbnwwfHwwfHx8Mg%3D%3D",
      title: "Manufacturing & Non-IT",
      description:
        "Non-IT solutions for production, logistics, and supply chain to drive efficiency and growth.",
    },
    {
      image:
        "https://1602894.fs1.hubspotusercontent-na1.net/hub/1602894/hubfs/60776739_l%20%281%29.webp?width=1170&name=60776739_l%20%281%29.webp",
      title: "Cybersecurity",
      description:
        "End-to-end security services including risk management, compliance, and cyber defense.",
    },
    {
      image:
        "https://images.unsplash.com/photo-1487611459768-bd414656ea10?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTQzfHxzb2Z0d2FyZXxlbnwwfHwwfHx8Mg%3D%3D",
      title: "Customer Support & BPO",
      description:
        "Empowering businesses with call center, customer care, and non-IT support services.",
    },
  ];

  return (
    <div className="aero-app">
      <h1>
        <span className="aero-highlight">Accelerators </span> {'   '}
        <span className="itnonit-font">for IT & Non-IT Services</span>
      </h1>

      <div className="carousel-controls">
        <button onClick={scrollLeft} className="arrow-button">
          &#8249;
        </button>
        <button onClick={scrollRight} className="arrow-button">
          &#8250;
        </button>
      </div>

      <div className="aero-card-wrapper">
        <div className="aero-card-container" ref={scrollRef}>
          {cards.map((card, index) => (
            <div className="aero-card" key={index}>
              <img
                src={card.image}
                alt={card.title}
                className="aero-card-image"
              />
              <h3 className="aero-card-title">{card.title}</h3>
              <p className="aero-card-description">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ITNonITAccelerator;
